export default "__VITE_ASSET__kjr9KPul__"